import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames'
import css from './index.css'
import Button from '~/components/common/Button';
import {modalClose, modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import accounting from '~/misc/accounting'
const textRenderFn = (type)  => (name, price) => {
  if(type === 'success') return `You’ve sent an offer to ${name} for ${price}`;
  return `You offer sent to ${name} for ${price} is failed`
}

const types = {
  'success': {
    iconSuffex: 'success',
    textRender: textRenderFn("success")
  },
  'fail': {
    iconSuffex: 'fail',
    textRender: textRenderFn("fail")
  }
}

class CreateBidResult extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { context } = this.props;
    const { result, message, brokerName, offer } = context;
    const { iconSuffex, textRender} = types[result];
    return (
      <div className={css.popwrap}>
        <div className={cs(css.icon,css['icon-'+iconSuffex])}></div>
        <div className={css.title}>{textRender(brokerName, accounting.formatMoney(offer))}</div>
        <div className={css.message}>{message}</div>
        <Button
          mods={['large', 'action']}
          onClick={this.props.closePop}
          className={css.button}
        >OK, Got it</Button>
      </div>
    )
  }
}

export default connect(null, mapDispatch({
  closePop: () => modalClose(modes.CREATE_BID_RESULT),
}))(CreateBidResult);


// WEBPACK FOOTER //
// ./src/components/Popup/CreateBidResult/index.js